import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromMonitoreoActions from './monitoreo.actions';
import { MonitoreoState } from './monitoreo.model';
import { Observable } from 'rxjs';
import * as fromSelectorMonitoreo from './monitoreo.selectors';
import { InformacionFiltroMensajeriaDto } from '../data/InformacionFiltroMensajeriaDto';

@Injectable({
  providedIn: 'root'
})
export class MonitoreoStoreService {

  constructor(private store: Store<MonitoreoState>) {
  }


  // COM Hora actualizacion ******
  public adicionarHora(newHora: string): void {
    this.store.dispatch(
      fromMonitoreoActions.addHoraActualizado({ newHora }));
  }

  public removeHora(): void {
    this.store.dispatch(
      fromMonitoreoActions.removeHoraActualizado());
  }

  // COM Contador de apertura Movil filtro *******
  public adicionarContador(newCounter: number): void {
    this.store.dispatch(
      fromMonitoreoActions.addContador({ newCounter }));
  }

  public removeContador(): void {
    this.store.dispatch(
      fromMonitoreoActions.removeContador());
  }



  public obtenerHoraActualizacion$(): Observable<string> {
    return this.store.select(fromSelectorMonitoreo.selectHora);
  }

  public obtenerContador$(): Observable<number> {
    return this.store.select(fromSelectorMonitoreo.selectContador);
  }



}
